<template>
  <label
    :for="id"
    class="CheckBox"
    :class="{ 'CheckBox--minus': isMinus }"
    @click="onClick"
  >
    <input
      :id="id"
      class="CheckBox__input"
      type="checkBox"
      :name="name"
      :checked="isChecked"
      :disabled="isDisabled"
      :aria-label="ariaLabel"
      :value="value"
      @change="$emit('input', $event)"
    />
    <span v-if="label" class="CheckBox__label" @click="onClick">{{
      label
    }}</span>
  </label>
</template>

<script>
export default {
  name: 'CheckBox',
  props: {
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Boolean],
      default: '',
    },
    ariaLabel: {
      type: String,
      default: '',
    },
    isChecked: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
    },
    isMinus: {
      type: Boolean,
    },
    onClick: {
      type: Function,
      default: null,
    },
  },
  emits: ['input'],
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

$checkOn: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjc5MzQgMTUuNzAxNEwxNy41MTg0IDguOTc2NDRMMTYuNDY4NCA3LjkyNjQ0TDEwLjc5MzQgMTMuNjAxNEw3Ljk0MzM2IDEwLjc1MTRMNi44OTMzNiAxMS44MDE0TDEwLjc5MzQgMTUuNzAxNFpNMy42OTMzNiAyMC4zNTE0VjMuMzUxNDRIMjAuNjkzNFYyMC4zNTE0SDMuNjkzMzZaIiBmaWxsPSIjMjY2N0Q3Ii8+Cjwvc3ZnPgo=';
$checkOff: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuNSAyMC41VjMuNUgyMC41VjIwLjVIMy41Wk01IDE5SDE5VjVINVYxOVoiIGZpbGw9IiMwODE5MkQiLz4KPC9zdmc+Cg==';
$disabled: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuOTY1NTIgMTIuOTc5OEgxNi40NjU1VjExLjQ3OThINi45NjU1MlYxMi45Nzk4Wk0zLjIxNTUyIDIwLjcyOThWMy43Mjk4MUgyMC4yMTU1VjIwLjcyOThIMy4yMTU1MloiIGZpbGw9IiNCRkJGQkYiLz4KPC9zdmc+Cg==';
$check-minus: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMjUgMTIuNzVIMTYuNzVWMTEuMjVINy4yNVYxMi43NVpNMy41IDIwLjVWMy41SDIwLjVWMjAuNUgzLjVaIiBmaWxsPSIjMjY2N0Q3Ii8+Cjwvc3ZnPgo=';
$check-size: $service-unit * 5;

.CheckBox {
  display: inline-flex;
  vertical-align: middle;

  &--minus &__input {
    &::after {
      background-image: url($check-minus);
    }
  }

  &__input {
    position: relative;
    width: $check-size;
    height: $check-size;
    padding: 0;
    margin: 0;
    background: none;
    border: none;
    border-radius: 0;
    appearance: none;

    &::after {
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      width: $check-size;
      height: $check-size;
      cursor: pointer;
      content: '';
      background: url($checkOff) no-repeat center / $check-size $check-size;
    }

    &:checked::after {
      background: url($checkOn) no-repeat center / $check-size $check-size;
    }

    &:disabled::after {
      cursor: inherit;
      background: url($disabled) no-repeat center / $check-size $check-size;
    }

    &:focus {
      outline: 2px solid $color-blue-60;
    }
  }

  &__label {
    padding-left: $service-unit * 2;
    font-size: $service-font-size-mp;
    cursor: pointer;
  }
}
</style>
